module.exports = __webpack_public_path__ + "img/code_img.f4fa6de8.png";